import { render, staticRenderFns } from "./coupon-active-form.vue?vue&type=template&id=4acf4c1c"
import script from "./coupon-active-form.vue?vue&type=script&lang=js"
export * from "./coupon-active-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports